<template>
  <div class="space-y-4">
    <QuotationInformation
      v-for="quotation in quotations"
      :key="quotation.id"
      :quotation="quotation"
      @updated="$emit('updated')"
    />
  </div>
</template>

<script>
import QuotationInformation from "@/components/claim/details/quotation/QuotationInformation.vue";

export default {
  props: {
    quotations: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["updated"],

  components: {
    QuotationInformation,
  },
};
</script>
